import { useRef, useEffect } from "react";
import { useInView } from "framer-motion";

// Wraps a full-viewport section and reports when it enters view so a parent
// can repaint background/type colors as CSS custom properties (Primefold-style
// continuous repaint, not a discrete section boundary).
export default function SectionReveal({
  bgColor,
  typeColor,
  accentColor,
  onEnter,
  children,
  className = "",
}) {
  const ref = useRef(null);
  const inView = useInView(ref, { amount: 0.5, margin: "-10% 0px -10% 0px" });

  useEffect(() => {
    if (inView) onEnter?.({ bgColor, typeColor, accentColor });
  }, [inView, bgColor, typeColor, accentColor, onEnter]);

  return (
    <section
      ref={ref}
      className={`relative flex min-h-screen w-full flex-col justify-center overflow-hidden ${className}`}
      style={{ color: typeColor }}
      data-bg={bgColor}
    >
      {children}
    </section>
  );
}
